import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';

export type DisclaimerSectionClasses =
  | 'disclaimerContainer'
  | 'disclaimerTitle'
  | 'disclaimerAccordionPaper'
  | 'disclaimerAccordionSummary'
  | 'disclaimerAccordionDetails'
  | 'disclaimerBody'
  | 'disclaimerPostcode';

const disclaimerSectionStyles = makeStyles<ISpcTheme, DisclaimerSectionClasses>(
  theme => ({
    disclaimerAccordionPaper: {
      backgroundColor: theme.palette.background.alternate,
    },
    disclaimerAccordionSummary: {
      backgroundColor: theme.palette.background.alternate,
    },
    disclaimerAccordionDetails: {
      flexDirection: 'column',
    },
    disclaimerContainer: {
      borderTop: `1px solid ${theme.palette.text.disabled}`,
      padding: `${theme.spacing(5)} ${theme.spacing(8)}`,
      backgroundColor: theme.palette.background.alternate,
      position: 'relative',
      zIndex: 999,

      [theme.breakpoints.down('md')]: {
        marginTop: 30,
        padding: '30px 16px',
      },
      [theme.breakpoints.down('sm')]: {
        borderTop: 'none',
      },
    },
    disclaimerTitle: {
      fontWeight: theme.typography.fontWeightBold,
      paddingBottom: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        paddingBottom: theme.spacing(1),
      },
    },
    disclaimerBody: {
      paddingBottom: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        paddingBottom: theme.spacing(1),
      },
    },
    disclaimerPostcode: {
      color: theme.palette.secondary.main,
      cursor: 'pointer',
      textDecoration: 'underline',
      textTransform: 'lowercase',
    },
  }),
  { name: 'Customise_DisclaimerSection' },
);

export default disclaimerSectionStyles;
